module.exports = __webpack_public_path__ + "img/sending_2.d21b604e.png";